import Button from 'apollo-react/components/Button';
import IconButton from 'apollo-react/components/IconButton';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import CopyIcon from 'apollo-react-icons/Copy';
import PencilIcon from 'apollo-react-icons/Pencil';
import DeleteIcon from 'apollo-react-icons/Trash';
import React, { useRef } from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';
import { getIndexForControlsInsideTable } from '../../utils/form-manager.utils';

const ActionCell = ({ row, column }) => {
  const translateString = useTranslation();
  const gridArrIndex = getIndexForControlsInsideTable(
    column.index,
    row[column.rowIndexKey],
    column.isParentlessTable
  );

  const divRef = useRef(null);

  const handleEdit = () => {
    column.handleEdit(row);
    setTimeout(() => divRef.current?.scrollIntoView({ block: 'nearest' }), 1000);
  };

  return (
    <div style={{ minWidth: 40, whiteSpace: 'nowrap' }} ref={divRef}>
      {column.handleEdit && row.isComplexTable && (
        <span
          ui-ta={getUITA(
            row.isDetail ? 'SSComplexGrid' : 'FormCtrl',
            row.isViewIconShown ? 'ViewButton' : 'EditButton',
            row.entityName
          )}
          data-pencil-icon-subgrid-instanceid={`${column.subgridId}#[${gridArrIndex}]`}
          data-pencil-icon-subgrid-expanded={
            column.useExpandableRows
              ? column.expandedRows.includes(`${row[column.rowIndexKey]}`)
              : column.selectedSubGrids.some(({ rowId }) => rowId === row.key)
          }
        >
          <IconButton
            size="medium"
            onClick={handleEdit}
            aria-label={translateString(row.isViewIconShown ? 'View' : 'Edit')}
          >
            {row.isViewIconShown ? (
              <ChevronRight
                style={{
                  width: '0.85em',
                  height: '0.85em',
                  transform: `rotate(${row.expanded ? 90 : 0}deg)`,
                }}
              />
            ) : (
              <PencilIcon />
            )}
          </IconButton>
        </span>
      )}
      {column.handleEdit && !row.isComplexTable && !row.isEditMode && (
        <span
          ui-ta={getUITA('FormCtrl', 'EditButton', row.entityName)}
          data-pencil-icon-rowid={`${row.key}`}
        >
          <IconButton size="medium" onClick={handleEdit} aria-label={translateString('Edit')}>
            <PencilIcon />
          </IconButton>
        </span>
      )}
      {column.handleDone && row.isEditMode && (
        <span ui-ta={getUITA('FormCtrl', 'DoneButton', row.entityName)}>
          <Button color="primary" variant="secondary" onClick={() => column.handleDone(row)}>
            {translateString('Done')}
          </Button>
        </span>
      )}
      {column.handleCopy && row.enableCopy && (row.editAllRows || !row.isEditMode) && (
        <span ui-ta={getUITA('FormCtrl', 'CopyButton', row.entityName)}>
          <IconButton
            size="medium"
            onClick={() => column.handleCopy(row)}
            aria-label={translateString('Copy')}
          >
            <CopyIcon />
          </IconButton>
        </span>
      )}
      {column.handleDelete && !row.disableDelete && (row.editAllRows || !row.isEditMode) && (
        <span ui-ta={getUITA('FormCtrl', 'DeleteButton', row.entityName)}>
          <IconButton
            size="medium"
            onClick={() => column.handleDelete(row)}
            aria-label={translateString('Delete')}
          >
            <DeleteIcon />
          </IconButton>
        </span>
      )}
    </div>
  );
};

export default ActionCell;
